import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TipoSolicitante } from '../models/TipoSolicitante';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoSolicitanteService {

  private LIST_TIPO_SOLICITANTE = environment.apiUrl + "ts/s"

  constructor(private httpClient: HttpClient) { }

  list(): Observable<TipoSolicitante[]> {
    return this.httpClient.get<TipoSolicitante[]>(this.LIST_TIPO_SOLICITANTE)
  }
}
